module.exports = __webpack_public_path__ + "img/the_basics--active.459afa46.svg";